import { gql } from 'apollo-angular';
import { ASSET_FRAGMENT } from '../../graphql/fragments.graphql';

export const EXTENDED_SEARCH_PRODUCTS = gql`
  query SearchProducts($input: SearchInput!) {
    extendedSearch(input: $input) {
      items {
        productId
        slug
        productName
        productVariantId
        productVariantName
        description
        sku
        inStock
        customAttributes {
        manufacturer {
          id
          name
          code
          asset {
              id
              preview
              focalPoint {
                x
                y
              }
          }

        }
        gridAttributes {
          languageCode
          name
          code
          value
        }
        productAttributes {
          languageCode
          name
          code
          value
        }
        stockLevel
      }
        priceWithTax {
          ... on PriceRange {
            min
            max
          }
        }
        productAsset {
          id
          preview
          focalPoint {
            x
            y
          }
        }
      }
      
      totalItems
      filters {
      top {
        id
        name
        code
        languageCode
        values {
          id
          name
          code
          count
          filterId
          languageCode
        }
      }
      left {
        id
        name
        code
        languageCode
        values {
          id
          name
          code
          count
          filterId
          languageCode
        }
      }
      }
    }
  }
`;

export const GET_COLLECTION = gql`
  query GetCollection($id: ID, $slug: String) {
    collection(id: $id, slug: $slug) {
      id
      name
      slug
      description
      populatable
      customFields {
        commingSoon
      }
      featuredAsset {
        ...Asset
      }
      breadcrumbs {
        id
        slug
        name
      }
      productsCount
      children {
        id
        productsCount
        slug
        featuredAsset {
          ...Asset
        }
        name
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
